import appStore from '@/store';

export const dispatchFetchDiff = (workspaceShortId: string, articleShortId: string, fromVersion: number) => {
  return appStore.dispatch('fetchDiff', { workspaceShortId, articleShortId, fromVersion });
};
